// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"quote-module--blockquote--BFxtj","cite":"quote-module--cite--1H9SR"};